import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import MediaUsageGuideModal from '@/components/container/modal/mediaUsageGuide/MediaUsageGuideModal'

interface MediaUsageGuideModalState {
  siteId: number
}

const defaultValue: MediaUsageGuideModalState = { siteId: 0 }

export const MediaUsageGuideModalContext =
  createModalContext<MediaUsageGuideModalState>(defaultValue)

const MediaUsageGuideModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<MediaUsageGuideModalState>(defaultValue)
  return (
    <MediaUsageGuideModalContext.Provider value={state}>
      {children}
      <MediaUsageGuideModal />
    </MediaUsageGuideModalContext.Provider>
  )
}

export default MediaUsageGuideModalProvider
